module.exports = __webpack_public_path__ + "static/avatar-martin-e3e3e7d451d8b9cca521121a06654c4c.jpg";